import ExternalImportsServices from './services';
export default function() {
  var self = this;

  self.$el = $('#js-external-imports');

  self.terms = JSON.parse($('#term-json').val());
  self.institutions = JSON.parse($('#institution-json').val());
  self.recaptcha_site_key = $('#recaptcha-site-key-json').val();
  self.type = $('#js-import-type').val();

  self.course = ko.observable({
    term_id: ko.observable(),
    institution_id: ko.observable()
  });

  self.sendCourseWelcome = ko.observable(true);
  self.sendInstitutionInvite = ko.observable(true);

  self.selectedTerm = ko.observable();
  self.selectedInstitution = ko.observable();

  if(self.type == 'course') {
    if (Kadenze.isKannu) {
      self.course().term_id.extend({required: true});
      self.selectedTerm.extend({required: true});
    } else {
      self.course().institution_id.extend({required: true});
      self.selectedInstitution.extend({required: true});
    }
    self.commonCartridge = ko.observable(false);
    self.ccImport = false;
  }

  self.importFile = function() {
    grecaptcha.enterprise.ready(function() {
      grecaptcha.enterprise.execute(self.recaptcha_site_key, {action: 'external_imports'}).then(function (token) {
        localStorage.setItem("recaptcha_token", token);
        var dz = self.getCurrentDropzone();
        if (dz.files.length === 1) {
          var errors = ko.validation.group(self);
          errors.showAllMessages(); // This will show the message on the field
          if(errors().length) {
            new Kadenze.Notice.error({ message: errors });
          } else {
            Kadenze.UIUtil.showLoadingIndicator(document.getElementById('js-external-imports'));
            dz.processQueue();
          }
        } else {
          if (dz.files.length === 1){
            new Kadenze.Notice.error({ message: 'Please add file to import' });
          }
        }
      });
    });
  };

  self.removeFile = function() {
    var dz = self.getCurrentDropzone();
    dz.removeAllFiles();
  };

  self.initUI = function() {
    self.dropzone = new ExternalImportsServices.initDropZones(self, self.$el.find('.js-import-dz'), false);
    self.ccDropzone = new ExternalImportsServices.initDropZones(self, self.$el.find('.js-common-cartridge-dz'), true);
    $('#js-common-cartridge-row').hide();
  };

  self.updateDropzone = function(value) {
    self.ccImport = value;
    $('#js-common-cartridge-row').toggle();
    $('#js-import-row').toggle();
  };

  self.getCurrentDropzone = function() {
    var dz;
    self.ccImport ? dz = self.ccDropzone : dz = self.dropzone;
    return dz;
  };

  if(self.type == 'course') {
    self.commonCartridge.subscribe(self.updateDropzone);
  }

  const __construct = function(that) {
    console.log('constructor called for ExternalImportsViewModel');
  }(this);
}
